const Home = () => (
  <svg
    focusable={false}
    xmlns='http://www.w3.org/2000/svg'
    width={48}
    height={48}
    viewBox='0 0 48 48'
  >
    <g fill='none' fillRule='evenodd'>
      <circle cx={24} cy={24} r={20} fill='#4B286D' />
      <path
        fill='#FFF'
        fillRule='nonzero'
        d='M27.08 32.14c0 .475.389.86.865.86h3.434c.478 0 .864-.39.864-.863v-8.058c0-.239.137-.301.31-.137l-.1-.095a.858.858 0 0 0 1.214-.03l.595-.625a.864.864 0 0 0-.031-1.222l-9.107-8.721a.909.909 0 0 0-1.25 0l-9.106 8.72a.867.867 0 0 0-.031 1.223l.595.625a.86.86 0 0 0 1.214.03l-.1.095c.17-.163.31-.1.31.137v8.058c0 .477.387.863.863.863h3.435c.477 0 .864-.39.864-.86v-5.613a2.588 2.588 0 0 1 2.581-2.59 2.584 2.584 0 0 1 2.582 2.59v5.612z'
      />
    </g>
  </svg>
);

export default Home;
